import api from './axios';

export const downloadOfferPdf = async (offerId: number, orderNo: string) => {
  const response = await api.get(`/pdf/offer/${offerId}`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${orderNo}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const previewOfferPdf = async (offerId: number): Promise<string> => {
  const response = await api.get(`/pdf/offer/${offerId}`, {
    responseType: 'blob',
  });
  return window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
};
